export default __webpack_public_path__ + "static/media/ant-logo.6f269e69.png";